function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter-2"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Row-Menu",
  transform: "translate(-448.000000, -344.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Lookbook-Gallery",
  transform: "translate(448.000000, 344.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#CDD4DA",
  x: 0.5,
  y: 0.5,
  width: 159,
  height: 107
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(6.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-10",
  fill: "#8C9BA8"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 72,
  height: 96
})), /*#__PURE__*/React.createElement("g", {
  id: "Icon/Book/M/White-Default",
  transform: "translate(24.000000, 36.000000)",
  filter: "url(#filter-1)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#000000",
  fillRule: "nonzero",
  opacity: 0,
  transform: "translate(12.000000, 12.000000) rotate(180.000000) translate(-12.000000, -12.000000) ",
  x: -1.77635684e-15,
  y: 1.77635684e-15,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.62,4.22 C20.384693,4.02965217 20.0758385,3.95611538 19.78,4.02 L12,5.77 L4.22,4 C3.91933627,3.93209492 3.60415793,4.00663987 3.3657702,4.20203964 C3.12738247,4.39743942 2.99242717,4.69185647 3,5 L3,17.2 C2.98835036,17.6766599 3.31484742,18.0952458 3.78,18.2 L11.78,20 L12.22,20 L20.22,18.2 C20.6851526,18.0952458 21.0116496,17.6766599 21,17.2 L21,5 C20.9985972,4.69572803 20.8587374,4.40864739 20.62,4.22 Z M5,6.25 L11,7.6 L11,17.75 L5,16.4 L5,6.25 Z M19,16.4 L13,17.75 L13,7.6 L19,6.25 L19,16.4 Z",
  id: "Shape",
  fill: "#000000",
  fillRule: "nonzero"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(82.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-10",
  fill: "#8C9BA8"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 72,
  height: 96
})), /*#__PURE__*/React.createElement("g", {
  id: "Icon/Book/M/White-Default",
  transform: "translate(24.000000, 36.000000)",
  filter: "url(#filter-2)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#000000",
  fillRule: "nonzero",
  opacity: 0,
  transform: "translate(12.000000, 12.000000) rotate(180.000000) translate(-12.000000, -12.000000) ",
  x: -1.77635684e-15,
  y: 1.77635684e-15,
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.62,4.22 C20.384693,4.02965217 20.0758385,3.95611538 19.78,4.02 L12,5.77 L4.22,4 C3.91933627,3.93209492 3.60415793,4.00663987 3.3657702,4.20203964 C3.12738247,4.39743942 2.99242717,4.69185647 3,5 L3,17.2 C2.98835036,17.6766599 3.31484742,18.0952458 3.78,18.2 L11.78,20 L12.22,20 L20.22,18.2 C20.6851526,18.0952458 21.0116496,17.6766599 21,17.2 L21,5 C20.9985972,4.69572803 20.8587374,4.40864739 20.62,4.22 Z M5,6.25 L11,7.6 L11,17.75 L5,16.4 L5,6.25 Z M19,16.4 L13,17.75 L13,7.6 L19,6.25 L19,16.4 Z",
  id: "Shape",
  fill: "#000000",
  fillRule: "nonzero"
})))))));

function SvgIconLookbookGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "108px",
    viewBox: "0 0 160 108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Lookbook Gallery") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLookbookGallery);
export default __webpack_public_path__ + "static/media/icon_lookbook_gallery.45f9610a.svg";
export { ForwardRef as ReactComponent };